import * as React from 'react';
import { Block, Text } from '../../../../../components';

interface StatusRequestProps {
  status: string;
  name: string;
}

const StatusRequest = (props: StatusRequestProps) => {
  const { status, name } = props;

  function evalTagColor() {
    if (name === 'Pendiente') return '#785900';
    if (
      [
        'CREADO',
        'PAGO_ACTIVADO',
        'PENDING_PROGRESS',
        'PENDING_PAY',
        'PENDING_MODIFY',
        'REGULARIZACION',
        'POR_ATENDER',
        'EN_PROCESO'
      ].includes(status)
    )
      return '#0060AB';

    if (
      [
        'PAGO_REALIZADO',
        'PENDIENTE',
        'PENDING_ATTENTION',
        'PEND_PROCESO'
      ].includes(status)
    )
      return '#785900';

    if (['NO_PROCEDE', 'FINALIZED_UNSUCCESS'].includes(status))
      return '#456271';

    if (status === 'ANULADO') return '#5E5E5E';

    return '#2D8746';
  }

  return (
    <Block
      flexDirection="row"
      customized
      width="100%"
      alignItems="self-end"
      data-testid="cmp-procedure-request-status"
    >
      <Block
        customized
        alignItems="center"
        padding="4px 12px 4px 12px"
        borderRadius="20px"
        maxWidth="fit-content"
        style={{ margin: '0' }}
        backgroundColor={evalTagColor()}
      >
        <Text
          color="#FFFFFF"
          fontSize="12px"
          lineHeight="16px"
          fontWeight="700"
          fontFamily="Lato"
        >
          {name === 'Regularización' ? 'Pendiente' : name}
        </Text>
      </Block>
    </Block>
  );
};

export default StatusRequest;
